import { render, staticRenderFns } from "./kongbai.vue?vue&type=template&id=7c3dab0a&scoped=true"
import script from "./kongbai.vue?vue&type=script&lang=js"
export * from "./kongbai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3dab0a",
  null
  
)

export default component.exports